// import React from 'react'
import { makeStyles } from '@mui/styles'

export const SPLIT_WEIGHT_OPTIONS = {
  EXISTING_MATERIALS: 'existing-materials',
  NEW_MATERIALS: 'new-materials',
}

export const splitOptions = [
  {
    id: SPLIT_WEIGHT_OPTIONS.EXISTING_MATERIALS,
    name: 'Split the differential among existing materials',
  },
  {
    id: SPLIT_WEIGHT_OPTIONS.NEW_MATERIALS,
    name: 'Split the differential among new materials',
  },
]

export const useStyles = makeStyles(theme => ({
  root: {
    border: 'none',
    paddingLeft: '36px',
    height: 'auto',
    '& .MuiDataGrid-columnsContainer': {
      display: 'none',
    },
    '& .MuiDataGrid-cell': {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      border: 'none',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-row': {
      '&.Mui-selected': {
        backgroundColor: 'inherit',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
      '&:not(.Mui-selected)': {
        backgroundColor: 'inherit',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0)',
        },
      },
    },
  },
}))

export const getActionBarButtons = (setOpenBlade, canSubmit) => [
  {
    id: 'submit-split-button',
    text: 'Save',
    type: 'submit',
    variant: 'contained',
    disabled: !canSubmit,
  },
  {
    id: 'exit-split-button',
    text: 'Cancel',
    variant: 'outlined',
    onClick: () => setOpenBlade(),
  },
]

export const calcTotalPercentage = allItems =>
  allItems.reduce((aggregate, item) => {
    const percentage = item.percentage ? item.percentage : 0
    return aggregate + percentage
  }, 0)

export const formatMaterials = (materials = []) =>
  materials.map(material => {
    const materialItem = material
    delete materialItem.code
    return materialItem
  })
